/* eslint-disable consistent-return */
import { allSections } from 'components/sections';
import { allWidgets } from 'components/widgets';

export function versionResolver(store, { sections }) {
  return Promise.all(sections.map(async (section) => {
    // Deleted sections should not be resolved
    if (!allSections[section.type]) {
      return Promise.resolve();
    }
    await sectionResolver(store, section);
    await Promise.all(section.widgets.map(async widget => widgetResolver(store, widget)));
  }));
}

export function sectionResolver(store, section) {
  const staticSection = allSections[section.type];
  return resolveHandler(store, staticSection, section);
}

export function widgetResolver(store, widget) {
  // Deleted widgets have a value of 'null' and should not be resolved.
  if (!widget) {
    return Promise.resolve();
  }

  const staticWidget = allWidgets[widget.type];

  if (!staticWidget) {
    return Promise.resolve();
  }

  return resolveHandler(store, staticWidget, { payload: {}, ...widget });
}

function resolveHandler(store, staticObject, object) {
  if (typeof staticObject.resolve === 'function') {
    let promises = staticObject.resolve({ store, ...object });

    if (promises) {
      if (!Array.isArray(promises)) {
        promises = [promises];
      }

      return Promise.all(promises.map((promiseOrAction) => {
        // If this object has a "then" function, assume this is a promise...
        if (typeof promiseOrAction.then === 'function') {
          return promiseOrAction;
        }

        // Otherwise, assume we're dealing with an action and dispatch it!
        return store.dispatch(promiseOrAction);
      }));
    }
  }

  return Promise.resolve();
}
